<script>
import { layoutMethods, erpFixMessages, peddlrWalletMethods, peddlrWalletComputed } from "@/state/helpers";
import { ToggleButton } from "vue-js-toggle-button";
import { required } from "vuelidate/lib/validators";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
export default {
  page: {
    title: "Kankolek Deposit",
  },
  data() {
    return {
      totalRows: 0,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 20, 30, 40, 50, 60, 70, 80, 90, 100],
      filter: null,
      filterOn: [],
      sortBy: "id",
      order: false,
      sortDesc: true,
      search: {
        status: '',
        reason: '',
        dateRange: null,
      },
      activeTab: 0,
      instapayIsActive: true,
      kolekIsActive: true,
      showWarningModal: false,
      reason: '',
      disableOptions : [
        { value: '', text: 'Select Reason', disabled: true},
        { text: 'Maintenance', value: 'Maintenance' },
        { text: 'Bugs/Issue', value: 'Bugs/Issue' },
        { text: 'Change in Business Strategy', value: 'Change in Business Strategy' },
        { text: 'Fraud Investigation', value: 'Fraud Investigation' },
      ],
      enableOptions : [
        { value: '', text: 'Select Reason', disabled: true},
        { text: 'Completed Maintenance', value: 'Completed Maintenance' },
        { text: 'Resolved Bugs/Issue', value: 'Resolved Bugs/Issue' },
        { text: 'Resolved Fraud Investigation', value: 'Fraud Investigation' },
      ],
      modalTitle: 'Deposit Via Peddlr kolek',
      methods: [
        { kankolek: 1, instapay: 1 }
      ],
      methodToUpdate: '',
      submitted: false,
      action: 'activate',
      showUpdateSuccessModal: false,
      showInfoModal: false,
      rangeOptions: {
        mode: "range",
      },
      statusOptions: [
        { value: '', text: 'Select Status' },
        { text: 'Active', value: 1 },
        { text: 'Inactive', value: 0 },
      ],
      reasonOptions: [
        { value: '', text: 'Select Reason' },
        { text: 'Maintenance', value: 'Maintenance' },
        { text: 'Bugs/Issue', value: 'Bugs/Issue' },
        { text: 'Change in Business Strategy', value: 'Change in Business Strategy' },
        { text: 'Fraud Investigation', value: 'Fraud Investigation' },
        { text: 'Completed Maintenance', value: 'Completed Maintenance' },
        { text: 'Resolved Bugs/Issue', value: 'Resolved Bugs/Issue' },
        { text: 'Resolved Fraud Investigation', value: 'Fraud Investigation' },
      ],
      fields: [
        { key: "status", sortable: true, },
        { key: "activity", sortable: true, },
        { key: "reason", sortable: true, },
        { key: "created_at", label: "Date Created", sortable: true, },
        { key: "updated_by", label: "Modified By", sortable: true, },
      ],
      isSearching: false,

    };
  },
  components: {
    ToggleButton,
    flatPickr
  },
  computed: {
    ...erpFixMessages,
    ...peddlrWalletComputed
  },
  validations: {
    reason: {required}
  },
  async mounted() {
    this.changeTitle({ title: "Deposit" });
    this.changeBreadCrumb({
      breadCrumbs: [
        { text: "Peddlr", to: { name: "Home" } },
        { text: "kankolek", to: { name: "" } },
        { text: "Deposit", to: { name: "" } },
      ],
    });

    await this.getCashInMethods();
    await this.getLogs();
  },
  methods: {
    ...layoutMethods,
    ...peddlrWalletMethods,
    async getCashInMethods() {
      await this.getKankolekCashinMethods()
        .then(() => {
          console.log('CASH IN METHODS: ', this.cashInMethods)
          this.instapayIsActive = this.cashInMethods.isInstaPayOn
          this.kolekIsActive = this.cashInMethods.isPeddlrKolekOn
        })
        .catch((e) => console.log(e))
    },
    showDeactivateModal(method) {
      this.methodToUpdate = method;
      if (!this.kolekIsActive && !this.instapayIsActive) {
        this.showInfoModal = true;
      } else {
        if(method == 'instapay') {
          this.modalTitle = 'Deposit Via InstaPay'
          this.action = this.instapayIsActive ? 'activate' : 'deactivate'
        } else if (method == 'kolek') {
          this.modalTitle = 'Deposit Via Peddlr kolek'
          this.action = this.kolekIsActive ? 'activate' : 'deactivate'
        }
        this.showWarningModal = true;
      }
    },
    async onSubmit() {
      this.submitted = true;
      if (this.reason == '') {
        return;
      }

      let params = {
        optionValue: {
          kankolek: this.kolekIsActive ? 1 : 0,
          instapay: this.instapayIsActive ? 1 : 0
        },
        method: this.methodToUpdate,
        status: this.action == 'activate' ? 'Active' : 'Inactive',
        reason: this.reason
      }

      await this.updateWalletCashinMethodStatus(params)
        .then(() => {
          this.showUpdateSuccessModal = true;
          this.showWarningModal = false;
        })
        .catch((err) => console.log(err));
    },
    onCancel(method) {
      if(method == 'instapay') {
        this.instapayIsActive = !this.instapayIsActive
      } else if (method == 'kolek') {
        this.kolekIsActive = !this.kolekIsActive
      }
      this.showWarningModal = false;
    },
    onInfoModalClose() {
      if(this.methodToUpdate == 'instapay') {
        this.instapayIsActive = !this.instapayIsActive
      } else if (this.methodToUpdate == 'kolek') {
        this.kolekIsActive = !this.kolekIsActive
      }
      this.showInfoModal = false;
    },
    async getLogs() {
      this.currentPage = this.isSearching ? 1 : this.currentPage;
      let params = {
        page: this.currentPage,
        rows: this.perPage,
        sort: this.sortBy,
        order: this.order,
        search: this.search
      };

      this.getKankolekCashinMethodLogs(params)
        .then(() => {
          this.isSearching = false;
        });
    },
    async tableSorting(action){
        console.log(action);
        var column = "";
        switch(action.sortBy){
            case 'status' :
                column = 'status';
                break;
            case 'activity' :
                column = 'activity';
                break;
            case 'reason' :
                column = 'reason';
                break;
            case 'created_at' :
                column = 'created_at';
                break;
            case 'updated_by' :
                column = 'updated_by';
                break;
        }
        
        this.sortBy = column;
        this.order = action.sortDesc ? 'DESC' : 'ASC';
        await this.getLogs()
    },
    async changeTab(tab) {
      if (tab == 'logs') {
        this.currentPage = 1;
        this.perPage = 10;
        this.sortBy = 'id',
        this.order = 'DESC',
        this.search = {
          status: '',
          reason: '',
          dateRange: null
        }
        await this.getLogs()
      }
    }
  },
};
</script>

<template>
  <div>
    <b-card>
      <b-tabs
        v-model="activeTab"
        content-class="py-4 px-2 text-muted"
        nav-class="nav-tabs-custom"
      >
        <!-- #region DEPOSIT TAB -->
        <b-tab class="border-0" @click="changeTab('deposit')">
          <template v-slot:title>
            <span class="d-none d-sm-inline-block">Deposit</span>
          </template>
          <b-row class="g-4">
            <div class="col-md-6 col-sm-12">
              <b-card>
                <div class="d-flex align-items-center">
                  <i class="mdi mdi-bank bank-icon px-4 me-3"></i>
                  <div>
                    <p class="m-0 fw-semibold text-primary fs-5">
                      Deposit Via InstaPay (P2P)
                    </p>
                    <p class="m-0 text-dark">Deposit via E-Wallets & Banks</p>
                  </div>
                </div>
                <hr class="mb-4" />
                <div class="d-flex">
                  <p class="m-0 fw-bold text-dark me-2">Status:</p>
                  <p class="m-0 fw-bold" 
                    :class="{ 
                      'text-success': instapayIsActive, 
                      'text-danger': !instapayIsActive 
                    }">{{ instapayIsActive ? "Active" : "Inactive" }}
                  </p>
                  <toggle-button
                    v-model="instapayIsActive"
                    class="ms-auto"
                    color="#e73092"
                    :sync="true"
                    @change="showDeactivateModal('instapay')"
                  />
                </div>
              </b-card>
            </div>
            <div class="col-md-6 col-sm-12">
                <b-card>
                <div class="d-flex align-items-center">
                  <i class="mdi mdi-qrcode bank-icon px-4 me-3"></i>
                  <div>
                    <p class="m-0 fw-semibold text-primary fs-5">
                        Deposit Via Peddlr kolek (P2M)
                    </p>
                    <p class="m-0 text-dark">Deposit via kolek QR from E-Wallets & Banks</p>
                  </div>
                </div>
                <hr class="mb-4" />
                <div class="d-flex">
                  <p class="m-0 fw-bold text-dark me-2">Status:</p>
                  <p class="m-0 fw-bold" 
                    :class="{ 
                      'text-success': kolekIsActive, 
                      'text-danger': !kolekIsActive 
                    }">{{ kolekIsActive ? "Active" : "Inactive" }}
                  </p>
                  <toggle-button
                    v-model="kolekIsActive"
                    class="ms-auto"
                    color="#e73092"
                    :sync="true"
                    @change="showDeactivateModal('kolek')"
                  />
                </div>
              </b-card>
            </div>
          </b-row>
        </b-tab>
        <!-- endregion -->

        <!-- #region LOGS TAB -->
        <b-tab class="border-0" @click="changeTab('logs')">
          <template v-slot:title>
            <span class="d-none d-sm-inline-block">Logs</span>
          </template>
          <div class="d-flex flex-wrap mt-3 mb-2 ta-right">
            <div class="me-2">
              <b-form-group label-for="kyc-account-type" description="Filter by Status">
                <b-form-select class="form-select rounded-0 rounded-start rounded-end shadow-none" style="width:160px"
                  id="kyc-account-type"
                  v-model="search.status"
                  :options="statusOptions"
                ></b-form-select>
              </b-form-group>
            </div>
            <div class="me-2">
              <b-form-group label-for="kyc-account-status" description="Filter by Reason">
                <b-form-select class="form-select rounded-0 rounded-start rounded-end shadow-none" style="width:160px"
                  id="kyc-account-status"
                  v-model="search.reason"
                  :options="reasonOptions"
                ></b-form-select>
              </b-form-group>
            </div>
            <div class="me-2">
              <b-form-group description="Filter by Date Range">
                <flat-pickr
                  v-model="search.dateRange"
                  :config="rangeOptions"
                  placeholder="Filter by Date Range"
                  class="form-control"
                  style="width: fit-content"
                ></flat-pickr>
              </b-form-group>
            </div>
            <div class="me-2">
              <a class="btn btn-primary h-fit" @click="isSearching = true; getLogs();">
                <i class='bx bx-search bx-fw'></i>Search
              </a>
            </div>
          </div>

          <div class="table-responsive mt-3">
            <div class="table align-middle table-nowrap">
              <b-table
                :items="cashinMethodsLogs"
                :fields="fields"
                responsive="sm"
                :current-page="currentPage"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                class="table-check"
                @sort-changed="tableSorting"
              >
                <template #cell(status)="data">
                  <div>{{ data.item.status == 1 ? 'Active' : 'Inactive' }}</div>
                </template>

                <template #cell(created_at)="data">
                  <div>{{ data.item.created_at | formatDate }}</div>
                </template>
              </b-table>
            </div>
          </div>

          <div class="row g-0 text-center" v-if="cashinMethodsLogsTotal == 0">
            <span>No data to display.</span>
          </div>
          <div class="row g-0 text-center text-sm-start" v-if="cashinMethodsLogsTotal != 0 && cashinMethodsLogsTotal > 10">
            <!-- end col -->
            <div class="col-sm-12">
              <div class="row">
                <div class="col">
                  <div class="form-group row pull-left">
                    <label for="staticEmail" class="col-sm-6 col-form-label">Display:</label>
                    <div class="col-sm-6">
                      <b-form-group label-for="display-record">
                        <b-form-select class="form-select shadow-none w-fit"
                          id="display-record"
                          v-model="perPage"
                          :options="pageOptions"
                          @change="isSearching = true; getLogs();"
                        ></b-form-select>
                      </b-form-group>
                    </div>
                  </div>
                  <div class="dataTables_paginate paging_simple_numbers float-end" v-if="cashinMethodsLogsTotal > perPage">
                    <!-- pagination -->
                    <b-pagination
                      class="pagination-rounded"
                      v-model="currentPage"
                      :total-rows="cashinMethodsLogsTotal"
                      @input="getLogs()"
                      :per-page="perPage"
                    ></b-pagination>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </b-tab>
        <!-- endregion -->
      </b-tabs>
    </b-card>

    <b-modal v-model="showWarningModal" size="md" centered hide-header hide-footer hide-header-close no-close-on-backdrop>
      <div class="px-2 py-3">
        <div class="col-md-12 text-center">
          <img src="@/assets/images/warning-yellow.png" style="width: 90px;" class="mb-2"/>
          <p class="fw-bold mt-2" style="font-size: 24px;">{{ modalTitle }}</p>
          <p class="mt-2 mb-0 deactivate-text" style="font-size: 18px;">Are you sure you want to {{ action }} the</p>
          <p class="mb-4 deactivate-text fw-semibold text-primary" style="font-size: 18px;">{{ modalTitle }}?</p>
          <b-form-select
            class="form-select" 
            v-model="reason"
            :options="action == 'activate' ? enableOptions : disableOptions"
            track-by="value"
            label="text"
            :state="submitted && reason == '' ? false : null"
            />
          <div class="d-flex justify-content-center mt-4">
            <button class="w-sm btn btn-primary" @click="onSubmit()">Yes</button>
            <button class="btn btn-secondary w-sm ms-2" @click="onCancel(methodToUpdate)">No</button>
          </div>
        </div>
      </div>
    </b-modal>
    <b-modal v-model="showUpdateSuccessModal" size="md" centered hide-header hide-footer hide-header-close no-close-on-backdrop>
      <div class="px-2 py-3">
        <div class="col-md-12 text-center">
          <img src="@/assets/images/check-circle.png" style="width: 90px;" class="mb-2"/>
          <p class="fw-bold mt-2" style="font-size: 24px;">Update Successful!</p>
          <p class="mt-2 mb-0" style="padding: 0 4rem; font-size: 18px;"><span class="text-primary fw-semibold">{{ modalTitle }}</span> has been updated and is now {{action}}d.</p>
          <div class="d-flex justify-content-center mt-4">
            <b-button variant="light" class="w-sm ok-btn" @click="showUpdateSuccessModal = false; getCashInMethods();">OK</b-button>
          </div>
        </div>
      </div>
    </b-modal>

    <b-modal v-model="showInfoModal" size="md" centered hide-header hide-footer hide-header-close no-close-on-backdrop>
      <div class="px-2 py-3">
        <div class="col-md-12 text-center">
          <img src="@/assets/images/warning-blue.png" style="width: 90px;" class="mb-2"/>
          <p class="fw-bold mt-2" style="font-size: 24px;">Info</p>
          <p class="mt-2 mb-0" style="padding: 0 2rem; font-size: 18px;">We can't disable both of the features.</p>
          <p class="mb-0" style="padding: 0 2rem; font-size: 18px;">Please select at least one feature to continue.</p>
          <div class="d-flex justify-content-center mt-4">
            <b-button class="w-sm ok-btn" @click="onInfoModalClose()">OK</b-button>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<style>
.bank-icon {
  color: #7f4697;
  font-size: 25px;
  border: solid 1px #d7c6df;
  border-radius: 50%;
  padding-top: 1.1rem;
  padding-bottom: 1.1rem;
}

.deactivate-text {
  padding-left: 4rem;
  padding-right: 4rem;
}

.ok-btn {
  border: 2px solid #B6B2EC;
}
</style>
